import React, { useEffect, useState } from "react";

const SubscriptionConfirmed = ({ isConfirmed = true }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Basic mobile detection using userAgent + width fallback
    if (typeof navigator === "undefined") return;

    const ua = navigator.userAgent || "";
    const mobileByUA = /android|iphone|ipad|ipod/i.test(ua);
    const mobileByWidth =
      typeof window !== "undefined" ? window.innerWidth <= 768 : false;

    setIsMobile(mobileByUA || mobileByWidth);
  }, []);

  const targetHref = isConfirmed && isMobile ? "invoiceu://auth/callback" : "/";

  const title = isConfirmed ? "Subscription confirmed" : "Subscription error";
  const description = isConfirmed
    ? isMobile
      ? "You’re all set. Open the app to continue."
      : "You’re all set. You can continue in the web app."
    : "We couldn’t confirm your subscription. Please return to the app and try again.";

  const primaryLabel =
    isConfirmed && isMobile
      ? "Open InvoiceU app"
      : isConfirmed
      ? "Back to InvoiceU"
      : "Back to home";

  return (
    <div className="flex flex-1 items-center justify-center">
      <section className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex flex-col gap-4">
          {/* Header */}
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-50">
              <span className="text-lg">{isConfirmed ? "✅" : "⚠️"}</span>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
              <p className="text-xs text-slate-500">{description}</p>
            </div>
          </div>

          {/* Body / Action */}
          <div className="mt-2 flex flex-col gap-2">
            <a
              href={targetHref}
              className="inline-flex items-center justify-center rounded-full bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
            >
              {primaryLabel}
            </a>
            <p className="text-[11px] text-slate-400">
              {isConfirmed && isMobile
                ? "If the app doesn’t open, make sure InvoiceU is installed and try again."
                : "You can safely close this page once you’ve continued."}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubscriptionConfirmed;
